<nz-card class="card">
  <h5>Issue Overview:</h5>
  <p *ngIf="enclosureBk">
    <b
      >{{ storageLevel.String | levelIdentifierToLevelName | titlecase }} Location:
      {{ enclosureBk | componentNameTranslation }} &rarr; {{ componentBk | componentNameTranslation }}</b
    >
  </p>
  <p>
    The <b>{{ parsePcsModuleBks() }} </b> disconnected from <b>{{ dcCombinerBk | componentNameTranslation }}</b
    >.<br />
    PCS units typically disconnect due to one or more of the following reasons:
  </p>
  <ul class="list-disc">
    <li>Grid disturbances (e.g., voltage or frequency outside allowed ranges)</li>
    <li>Thermal issues (ambient or internal overheating)</li>
    <li>Internal faults (component failures such as fan, IGBT, or insulation resistance)</li>
    <li>Protection functions triggered by overcurrent, overvoltage, or undervoltage</li>
  </ul>
  <br />
  <p>
    PCS units generally enter a fault or protection state when these conditions arise and may either attempt automatic recovery or
    require manual intervention.
  </p>
</nz-card>
<nz-card class="card">
  <h5>Why This Matters for You:</h5>
  <ul class="list-disc">
    <li>PCS disconnections reduce energy throughput and impact revenue.</li>
    <li>Repeated or unresolved faults impact long-term system reliability and may accelerate component aging.</li>
    <li>Determining the root cause early helps reduce downtime and prevent recurrence.</li>
  </ul>
</nz-card>
<nz-card class="card">
  <h5>Recommendations:</h5>
  <ul class="list-disc">
    <li>Determine the current PCS status (e.g., fault, emergency stop, protection mode).</li>
    <li>
      Review event logs, fault codes, and signals in the TWAICE Data Explorer to identify if the trip was due to:
      <ul class="list-disc">
        <li>Grid-side fluctuations (voltage, frequency)</li>
        <li>High ambient or internal temperature</li>
        <li>Overcurrent, overvoltage, or insulation-related faults</li>
        <li>Component-specific failures (e.g., fan malfunction)</li>
      </ul>
    </li>
  </ul>
</nz-card>
<nz-card class="card">
  <h5>Documenting the issue:</h5>
  <ul class="list-disc">
    <li>Export the PCS event logs with at least 30 minutes of data before and after the trip.</li>
    <li>
      Capture relevant charts showing key parameters such as:
      <ul class="list-disc">
        <li>AC/DC voltage and current</li>
        <li>Grid frequency</li>
        <li>Internal and ambient temperature</li>
      </ul>
    </li>
    <li>Annotate the data with the PCS ID, timestamp of failure, and any visible symptom</li>
  </ul>
</nz-card>
<nz-card class="card">
  <h5>Guidance for Collaboration with Service and Hardware Providers:</h5>
  <ul class="list-disc">
    <li>Share logs, visual trends, and fault descriptions with your O&M team or OEM.</li>
    <li>Request component health diagnostics if faults involve hardware (fans, IGBTs, sensors).</li>
    <li>If recurring, ask for a review of PCS protection thresholds and recovery logic.</li>
    <li>Align on whether a firmware update, threshold adjustment, or preventative replacement is warranted.</li>
  </ul>
</nz-card>
